<template>
  <div class="nav-wrapper">
    <img class="show-nav" src="@/assets/img/sidenav.png"/>
    <MDBIcon class="hide-nav" icon="angle-left" size="2x" @click="hideNav" v-show="showNavClose"/>
    <div id="sidenav" aria-controls="#sidenav" @click="showNav">
      <PlexSideNav v-model="sidenav" :relative="true">
        <h2 v-html="i18n.title('Landing')"/>
        <div id="view-capabilities">
          <MDBSwitch
            :label="i18n.title('ViewCapabilities')"
            v-model="viewCapabilities"
            />
        </div>
        <MDBSideNavMenu>
          <div id="main-nav" v-if="!viewCapabilities">
            <MDBSideNavItem v-for="nav in getHotspots" :key="'nav' + nav.id">
              <MDBSideNavLink @click="click(nav.id)">
                <div class="item">
                  <h3 v-html="i18n.title(nav.id)"/>
                  <p class="desc" v-html="i18n.value('nav_desc_' + nav.id)"/>
                </div>
              </MDBSideNavLink>
            </MDBSideNavItem>
          </div>
          <div id="capabilities-nav" v-if="viewCapabilities">
            <div class="capability group" @click="click('Office')">
              <h3 v-html="i18n.title('Office')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('DemandPlan')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('Forecasting')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('MRP')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('OEE')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdAnalytics')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdCapacity')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdScheduling')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('SOP')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ScrapCost')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ScrapReport')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('SupplyChainPlan')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('VisPlant')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('InjectionMolder')">
              <h3 v-html="i18n.title('InjectionMolder')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('CPanel')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('InlineQuality')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('MachineStatus')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdRecording')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('RawMatValid')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ScrapRecord')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('SPC')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ToolMgmt')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('Heat')">
              <h3 v-html="i18n.title('Heat')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('Alerts')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ConditionMaint')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('MachineHealth')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('MachineVarThresh')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProcParamTrack')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('TimeSeriesData')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('Mobile')">
              <h3 v-html="i18n.title('Mobile')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('BarcodeScan')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('InvTrace')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdMgmt')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('RawMatLoad')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('PackLabel')">
              <h3 v-html="i18n.title('PackLabel')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('LabelGen')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('LabelPrint')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('Packing')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('Paint')">
              <h3 v-html="i18n.title('Paint')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('BatchMgmt')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('InvTrace')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('LabelGen')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('OEE')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProcParamTrack')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdRecording')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('RTKPI')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('SPC')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('PlantAnalytics')">
              <h3 v-html="i18n.title('PlantAnalytics')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('OEE')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('RTKPI')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('VWhiteboard')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('VisPlant')"/>
              </MDBSideNavItem>
            </div>
            <hr class="divider"/>
            <div class="capability group" @click="click('Shipping')">
              <h3 v-html="i18n.title('Shipping')"/>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('CustShipHist')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('InvTrace')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('LabelGen')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ProdGen')"/>
              </MDBSideNavItem>
              <MDBSideNavItem>
                <MDBSideNavLink v-html="i18n.capability('ShipPaper')"/>
              </MDBSideNavItem>
            </div>
          </div>
        </MDBSideNavMenu>
      </PlexSideNav>
    </div>
  </div>
</template>

<script>
import { inject, ref, watch } from 'vue'
import { mapGetters, mapMutations, useStore } from 'vuex'

import {
  MDBIcon,
  MDBSideNavMenu,
  MDBSideNavItem,
  MDBSideNavLink,
  MDBSwitch
} from '@/index.pro.js'

import PlexSideNav from '@/components/mdb/PlexSideNav'

export default {
  components: {
    MDBIcon,
    MDBSideNavMenu,
    MDBSideNavItem,
    MDBSideNavLink,
    MDBSwitch,
    PlexSideNav
  },
  computed: {
    ...mapGetters([
      'getHotspots',
      'getNavShowing'
    ])
  },
  methods: {
    click (id) {
      this.$emit('select', id)
    },
    hideNav () {
      console.log('hideNav')
      this.setNavShowing(false)
    },
    showNav () {
      console.log('showNav')
      this.setNavShowing(true)
    },
    ...mapMutations([
      'setNavShowing'
    ])
  },
  name: 'MainNav',
  setup () {
    const i18n = inject('i18n')
    const showNavClose = ref(false)
    const sidenav = ref(false)
    const store = useStore()
    console.log(store)
    const viewCapabilities = ref(false)
    watch(() => store.getters.getNavShowing, (sidenavValue) => {
      sidenav.value = sidenavValue
      if (sidenavValue) {
        setTimeout(() => {
          showNavClose.value = true
        }, 400)
      } else {
        showNavClose.value = sidenavValue
      }
    })
    return { i18n, showNavClose, sidenav, viewCapabilities }
  }

}
</script>

<style lang="scss">
.hide-nav {
  font-size: 4vh;
  position: absolute;
  top: 41.5vh;
  left: 14.5%;
  z-index: 1001;
}

.show-nav {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
}

#capabilities-nav, #view-capabilities {
  padding: 0 1.5rem;

  h3 {
    margin-bottom: 0;
  }

  .divider {
    border-top: 2px solid #ffffff;
  }
}

#sidenav {
  line-height: 1.25;
  position: fixed;
  height: 100vh;
  width: 16%;
  left: 0;
  top: 0;

  h2 {
    font-size: 1.75rem;
    font-weight: 800;
    line-height: 1;
    margin: 1.5rem;
  }

  .item {
    width: 100%;
  }

  .ps--active-y > .ps__rail-y {
    display: none;
  }

  .sidenav {
    background-image: linear-gradient(
      170deg,
      hsl(210deg 100% 25%) 0%,
      hsl(207deg 100% 29%) 21%,
      hsl(204deg 100% 34%) 34%,
      hsl(201deg 100% 38%) 44%,
      hsl(199deg 100% 43%) 51%,
      hsl(196deg 100% 47%) 58%,
      hsl(193deg 100% 48%) 65%,
      hsl(190deg 100% 47%) 73%,
      hsl(186deg 100% 47%) 81%,
      hsl(181deg 100% 45%) 90%,
      hsl(174deg 84% 58%) 100%
    );
    width: 100%;
    height: 90vh;
  }

  .sidenav-link {
    height: auto;
    padding: 0.5rem 1.5rem;
    white-space: normal;

    h3, p {
      margin-bottom: 0;
    }

    h3 {
      font-size: 1.25rem;
      text-transform: uppercase;
    }

    p {
      line-height: 1.4;
    }
  }

  .sidenav-menu {
    padding-bottom: 2rem;
    width: 90%;
  }

  #view-capabilities {
    margin-bottom: 1rem;
    text-transform: uppercase;
  }
}
</style>
